import { action, observable } from 'mobx';
import { IS_NATIVE_APP_CLIENT } from 'src/scripts/utils/helpers';

export const OPEN_DISCOUNT_SIGNUP_MODAL = 'open-signup-discount-modal';
export const DiscountSignupModalState = observable({
  isOpen: false,
});
export const openDiscountSignupModal = action(() => {
  if (!IS_NATIVE_APP_CLIENT) DiscountSignupModalState.isOpen = true;
});
export const closeDiscountSignupModal = action(() => {
  DiscountSignupModalState.isOpen = false;
});
document.addEventListener(OPEN_DISCOUNT_SIGNUP_MODAL, openDiscountSignupModal);
export const dispatchOpenDiscountSignupEvent = () => document.dispatchEvent(new Event(OPEN_DISCOUNT_SIGNUP_MODAL));
